<template>
  <div
    class="bto-sb-builder-item"
    ref="btoBetBuilderItem"
    :class="{ 'bto-sb-builder-item-error': showUnselectedError && showError }">
    <div
      v-if="items.length > 3"
      class="bto-sb-dropdown-search"
      :data-bb-item-open="isOpen"
      @click="toggleSelect"
      :class="{ 'bto-sb-open': isOpen, 'bto-sb-searchlast': isOpen && isAtBottom }">
      <a class="bto-sb-dropdown-name" :class="{ 'bto-sb-event-odd-active': selectedOutcomeId }">
        <span v-if="selectedOutcomeName">{{ selectedOutcomeName }}</span>
        <span v-else>
          {{ itemsHint }}
        </span>
      </a>
      <div @click.stop="" class="bto-sb-search" ref="betBuilderSearchContainer">
        <div class="bto-sb-search-content">
          <span class="bto-app-bet-search"></span>
          <input
            type="text"
            class="bto-sb-form-input"
            v-model="searchFilter"
            ref="betbuilderSearch" />
        </div>
        <ul class="bto-sb-scrollbar">
          <li v-for="(item, idx) in filteredItems" :key="idx">
            <a @click="toggleOutcome(item)">{{ item.Value }}</a>
          </li>
        </ul>
      </div>
    </div>
    <component
      :is="isUsLayout ? 'empty-component' : 'div'"
      v-else
      class="bto-sb-event-mormarket-market-odd bto-sb-event-mormarket-market-oddonly">
      <component
        :is="isUsLayout ? 'span' : 'a'"
        v-for="(item, idx) in items"
        :key="idx"
        class="bto-sb-event-odd"
        @click="toggleOutcome(item)"
        :class="getItemActiveClass(item)">
        <i>{{ item.Value }}</i>
      </component>
    </component>
  </div>
</template>
<script>
  import { EmptyComponent } from '@bto-widgets/utils/shared';
  import { checkLayout } from 'bto-models/app-settings/web';

  export default {
    name: 'BetBuilderItem',
    components: { EmptyComponent },
    props: {
      items: {
        type: Array,
        required: true,
      },
      itemLvl: {
        type: Number,
        required: true,
      },
      selectedOutcomeId: {
        type: Number,
        default: 0,
      },
      isComplexItem: {
        type: Boolean,
        required: true,
      },
      showError: {
        type: Boolean,
        default: false,
      },
      selectedGlobalId: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        isOpen: false,
        isAtBottom: false,
        searchFilter: '',
      };
    },
    computed: {
      isUsLayout() {
        return checkLayout('US');
      },
      filteredItems() {
        return this.items.filter(item => `${item.Value}`.toLowerCase().includes(this.searchFilter.toLowerCase()));
      },
      showUnselectedError() {
        return !this.selectedOutcomeId;
      },
      selectedOutcomeName() {
        const item = this.items.find(it => it.Id === this.selectedOutcomeId);
        return item ? item.Value : '';
      },
      itemsHint() {
        return this.items.slice(0, 4).map((i) => i.Value).join(",");
      },
    },
    created() {
      // If we have part of market selected and current part of market has only 1 selection preselect it
      if (this.itemLvl > 0 && this.items.length === 1) {
        this.toggleOutcome(this.items[0]);
      }
    },
    methods: {
      getItemActiveClass(item) {
        const isActive = this.isSimpleMarketActive(item);
        if (isActive && this.isUsLayout) {
          return 'bto-sb-event-odd-active';
        }
        if (isActive) {
          return 'bto-sb-event-mormarket-market-odd-active';
        }
        return '';
      },
      checkSelectPosition() {
        const parentQuery = this.isUsLayout ? '.bto-sb-matchdetails-wrap' : '.bto-sb-event-mormarket';
        const parentEl = document.querySelector(parentQuery);
        if (!parentEl) return;
        const parentBottom = parentEl.getBoundingClientRect().bottom;
        const itemBottom = this.$refs['btoBetBuilderItem'].getBoundingClientRect().bottom;
        const itemHeight = this.$refs['betBuilderSearchContainer'].getBoundingClientRect().height;
        this.isAtBottom = (parentBottom - itemBottom - itemHeight) <= 0;
      },
      isSimpleMarketActive(item) {
        const activeGlobalId = this.selectedGlobalId ? this.selectedGlobalId.GlobalIdLong : '-2';
        if (this.selectedGlobalId) {
          return item.GlobalIdLong === activeGlobalId;
        }
        return this.selectedOutcomeId === item.Id;
      },
      toggleOutcome(item) {
        if (this.selectedOutcomeId === item.Id && this.isComplexItem) {
          this.resetSelect();
          return;
        }
        this.isOpen = false;
        this.$emit('onItemSelect', {
          items: item.Items,
          itemLvl: this.itemLvl,
          selection: item.Id,
          globalId: item.GlobalIdLong,
          description: item.Description,
        });
      },
      toggleSelect() {
        // If we are oppening the select clse all other active selects
        if (!this.isOpen) {
          document.querySelectorAll('[data-bb-item-open]').forEach(el => {
            el.dispatchEvent(new Event('click'));
          });
        }
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
          this.resetSelect();
          this.$nextTick(() => {
            this.$refs.betbuilderSearch.focus();
            this.checkSelectPosition();
          });
        }
      },
      resetSelect() {
        this.$emit('onItemSelect', { items: null, itemLvl: this.itemLvl });
      },
    },
  };
</script>
